/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $MoveFunctionVisibility = {
    type: 'Enum',
} as const;
